import { setCodeoBrands, setIsLoadingBrands } from './codeoSlice';

import { ApiService } from 'js/src/client';
import { ErrorReporter } from 'js/src/libs/error-reporter';
import type { AppDispatch, RootState } from 'js/src/libs/RootState';

export const loadCodeoBrands = () => async (dispatch: AppDispatch, getState: () => RootState) => {
    if (getState().codeo.isLoadingBrands) {
        return;
    }
    dispatch(setIsLoadingBrands(true));
    try {
        const response = await ApiService.codeoBrandsList();
        dispatch(setCodeoBrands(response.data ?? []));
    } catch (error) {
        ErrorReporter.capture(error);
    } finally {
        dispatch(setIsLoadingBrands(false));
    }
};
